import React from "react";
import {
  booking,
  dressCode,
  giftCardPolicy,
  rateNotices,
  siteImages,
} from "../data/redlandGolfContent";
import { useSiteContent } from "../context/ContentContext";
import { ButtonLink } from "../components/ButtonLink";
import {
  Accordion,
  Breadcrumbs,
  Card,
  HoursTable,
  PageHero,
  PolicyAlert,
  PriceList,
  RateTable,
  SectionHeading,
} from "../components/RedlandComponents";

function CtaCallout({ contact }) {
  return (
    <Card className="tee-time-card">
      <h2>Book your tee time by calling 305-247-8503, extension 1.</h2>
      <ButtonLink href={contact.phoneHref}>Call for Tee Times</ButtonLink>
    </Card>
  );
}

export default function Rates() {
  const { rates, hours, contact } = useSiteContent();
  return (
    <>
      <Breadcrumbs current="Rates" />
      <PageHero
        eyebrow="Simple, Transparent Golf Rates"
        title="Rates, Fees & Promos"
        copy="Rates include cart and sales tax. Call the Pro Shop for tee times and current availability."
        image={siteImages.golfCart}
        badge="Rates Include Cart and Sales Tax"
        tags={["Weekday Rates", "Weekend Rates", "Range Balls", "First Responder Days"]}
        metaTitle="Pro Shop"
        metaItems={["305-247-8503", "Extension 1", "Open to the public"]}
        actions={
          <ButtonLink href={booking.href} ariaLabel={booking.note}>
            Book a Tee Time
          </ButtonLink>
        }
      />
      <section className="section">
        <div className="container">
          <PolicyAlert title="Rate Notices">
            <ul className="clean-list">
              {rateNotices.map((notice) => (
                <li key={notice}>{notice}</li>
              ))}
            </ul>
          </PolicyAlert>

          {rates.specials ? (
            <PolicyAlert title="Current Specials" tone="green" data-testid="rates-specials-alert">
              {rates.specials}
            </PolicyAlert>
          ) : null}

          <div className="card-grid two rate-grid">
            <RateTable title="Weekday Rates" rows={rates.weekday} />
            <RateTable title="Weekend Rates" rows={rates.weekend} />
          </div>

          <CtaCallout contact={contact} />

          <div className="card-grid two">
            <PriceList title="Additional Fees" rows={rates.additionalFees} />
            <PriceList title="Range Balls" rows={rates.rangeBalls} />
          </div>
        </div>
      </section>

      <section className="section section-cream">
        <div className="container">
          <Accordion title="Holiday Rates" open>
            <div className="holiday-grid">
              {rates.holidayRatesApplyOn.map((holiday) => (
                <span key={holiday}>{holiday}</span>
              ))}
            </div>
            <ul className="notice-list">
              {rates.holidayNotices.map((notice) => (
                <li key={notice}>{notice}</li>
              ))}
            </ul>
          </Accordion>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading title="First Responders Days" copy="Thank you for your service!" />
          <div className="card-grid two">
            <Card>
              <h3>Days</h3>
              <ul className="pill-list">
                {rates.firstResponderDays.map((day) => (
                  <li key={day}>{day}</li>
                ))}
              </ul>
            </Card>
            <Card>
              <h3>The $50 rate includes</h3>
              <ul className="clean-list">
                {rates.firstResponderIncludes.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </Card>
          </div>
        </div>
      </section>

      <section className="section section-cream">
        <div className="container">
          <SectionHeading title="Winter Hours of Operation" copy={hours.effectiveDate} />
          <HoursTable rows={hours.rows} />
          <p className="fine-print">{hours.notice}</p>
          <p className="fine-print">
            Sand Trap telephone: <a href={contact.phoneHref}>{hours.sandTrapPhone}</a>
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container card-grid two">
          <PolicyAlert title="Dress Code" tone="green">
            <ul className="clean-list">
              {dressCode.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </PolicyAlert>
          <PolicyAlert title="Gift Card Policy">{giftCardPolicy}</PolicyAlert>
        </div>
      </section>

      <section className="section weather-section">
        <div className="container">
          <Card className="weather-card">
            <div>
              <p className="eyebrow">Homestead Weather</p>
              <h2>Current Weather Link</h2>
              <p>
                Live weather is not connected yet. Use the link below to search current Homestead
                weather.
              </p>
            </div>
            <ButtonLink
              href="https://www.google.com/search?q=Homestead%20Florida%20weather"
              variant="secondary"
            >
              Search Homestead Weather
            </ButtonLink>
          </Card>
        </div>
      </section>
    </>
  );
}
